import { render } from "./SortTableRowComponent.vue?vue&type=template&id=2b4d1fb4&scoped=true"
import script from "./SortTableRowComponent.vue?vue&type=script&lang=js"
export * from "./SortTableRowComponent.vue?vue&type=script&lang=js"

import "./SortTableRowComponent.vue?vue&type=style&index=0&id=2b4d1fb4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4d1fb4"]])

export default __exports__